import type { BookingData } from './booking-data';

export const defaultClassType = { id: 2, name: 'Private In-Home' };

export const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const defaultBookingData: BookingData = {
	class_type_id: defaultClassType.id,
	age_ids: null,
	club_id: null,
	semester_id: null,
	experience_level_ids: null,
	lesson_type_ids: null,
	location_id: null,
	offer_id: null,
	prefered_start_date: null,
	prefered_times: [{ dow: '', time_from: '5:00 AM', time_to: '9:00 AM' }],
	prefered_tz: defaultTimezone,
	stripe_customer_id: null,
	stripe_payment_method_id: null,
	student_ids: null,
	tz: defaultTimezone,
	totalPrice: null,
	notes: null,
	address: {
		address1: null,
		city: null,
		country: null,
		latitude: null,
		longitude: null,
		state: null,
		zip: null
	},
	email: null,
	gender: null,
	nameFirst: null,
	nameLast: null,
	phone: null,
	sourceId: null,
	checkout_result: null,
	registration_result: null,
	prefered_result: null,
	featureOnCalendar: false,
	utmOptions: {
		utm_source: null,
		utm_medium: null,
		utm_campaign: null,
		utm_term: null,
		utm_content: null
	},
	code: null,
	bundleId: null,
	dropIn: false
};
